import { render, staticRenderFns } from "./Fellowship.vue?vue&type=template&id=94d679cc&"
import script from "./Fellowship.vue?vue&type=script&lang=js&"
export * from "./Fellowship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports